import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',

  theme: {
    primary: '#1A0070',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#df040b',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#fb8c00',

    iK: '#df040b'
  }
})
